import { render, staticRenderFns } from "./SearchCategory.vue?vue&type=template&id=c0d69354&scoped=true&"
import script from "./SearchCategory.vue?vue&type=script&lang=ts&"
export * from "./SearchCategory.vue?vue&type=script&lang=ts&"
import style0 from "./SearchCategory.vue?vue&type=style&index=0&id=c0d69354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d69354",
  null
  
)

export default component.exports